var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"py-0 px-0"},[_c('vue-page-transition',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }